/**
 * Icon Component
 *
 * Renders SVG icons from the sprite sheet for optimised performance.
 * Icons are loaded from the generated sprite at dist/images/icons.svg
 *
 * @package
 */

const ICON_SIZES = {
	small: { width: 16, height: 16 },
	medium: { width: 18, height: 18 },
	large: { width: 24, height: 24 },
};

const AVAILABLE_ICONS = [
	'arrow-right',
	'plus',
	'download',
	'close',
	'share',
	'information',
	'minus',
	'spanner',
];

/**
 * Icon component using SVG sprite
 *
 * @param {Object} props           Component props.
 * @param {string} props.name      Icon name (e.g., 'arrow-right', 'close').
 * @param {string} props.size      Icon size: 'small', 'medium', or 'large'. Default: 'medium'.
 * @param {string} props.className Additional CSS class names.
 * @param {Object} props.style     Inline styles.
 * @param {number} props.width     Custom width (overrides size).
 * @param {number} props.height    Custom height (overrides size).
 * @return {JSX.Element} Icon component.
 */
const Icon = ( { name, size = 'medium', className = '', style = {}, width, height } ) => {
	if ( ! AVAILABLE_ICONS.includes( name ) ) {
		// eslint-disable-next-line no-console
		console.warn( `Icon "${ name }" not found. Available icons:`, AVAILABLE_ICONS );
		return null;
	}

	const dimensions = ICON_SIZES[ size ] || ICON_SIZES.medium;
	const iconWidth = width || dimensions.width;
	const iconHeight = height || dimensions.height;

	// Path to the sprite file - WordPress will handle the proper URL resolution.
	const spriteUrl = `${ atConfigurator.pluginUrl }dist/images/icons.svg`;

	return (
		<svg
			className={ className }
			style={ style }
			width={ iconWidth }
			height={ iconHeight }
			aria-hidden="true"
		>
			<use xlinkHref={ `${ spriteUrl }#${ name }` } />
		</svg>
	);
};

export default Icon;
